/* eslint no-unused-vars:0 */

import axios from "axios";
import Beneficiary from "@/store/models/household/Beneficiary";

export const beneficiaries = {
    namespaced: true,
    state: {
        beneficiaries: [],
    },
    actions: {
        loadBeneficiaries ({ commit, getters, rootGetters }) {
            return axios
                .get('/api/household/' + rootGetters['auth/user'].household_id + '/beneficiaries')
                .then(response => {
                    commit('setBeneficiaries', response.data.data.beneficiaries);
                    return response;
                })
        },
    },
    mutations: {
        setBeneficiaries (state, beneficiaries) {
            Beneficiary.create({data: beneficiaries})
            state.beneficiaries = beneficiaries;
        },
    },
};
